<template>
  <!-- Skip Link - WCAG 2.2 SC 2.4.1 -->
  <a href="#main-content" class="skip-link">Skip to main content</a>

  <main 
    id="main-content" 
    role="main" 
    :class="[
      'min-h-screen transition-colors duration-300',
      route.meta.standalone ? '' : 'flex flex-col justify-between'
    ]"
  >
    <!-- Floating Theme Switcher in the top-right corner -->
    <div class="fixed top-4 right-4 z-50">
      <ThemeSwitcher />
    </div>

    <!-- Router View container -->
    <div 
      :class="[
        route.meta.standalone ? 'w-full' : 'flex-grow flex items-center justify-center py-6 w-full'
      ]"
    >
      <router-view />
    </div>

    <!-- PWA Bottom Navigation bar or footer -->
    <footer 
      v-if="!route.meta.standalone"
      class="py-4 border-t border-[var(--pwa-border)] bg-[var(--pwa-surface)]/80 backdrop-blur-md text-center text-[10px] text-[var(--pwa-text-muted)] font-medium transition-colors duration-300"
    >
      &copy; 2026 Rameria. All Rights Reserved.
    </footer>
  </main>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import ThemeSwitcher from './components/ThemeSwitcher.vue';

const route = useRoute()

// Anti-FOUC: Initialize theme before render
onMounted(() => {
  // Theme already set by inline script in index.html
  // Setup Intersection Observer for scroll animations fallback
  if (!CSS.supports('animation-timeline: scroll()')) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    )

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el))
  }
})
</script>

<style>
@import './styles/main.css';
</style>
